let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7A8XO")).then(() => parcelRequire('hd4f0'));